import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "container p-0" };
const _hoisted_2 = {
    key: 0,
    class: "row ms-2 me-2"
};
const _hoisted_3 = { class: "col-12" };
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("div", { class: "row mb-2" }, [
    /*#__PURE__*/ _createElementVNode("div", {
        class: "col-12 fw-bold",
        style: { "margin-top": "2px" }
    }, " Zusammenfassung ")
], -1);
const _hoisted_5 = { class: "row mb-2" };
const _hoisted_6 = { class: "col-9" };
const _hoisted_7 = { class: "col-3 text-end fw-bold" };
const _hoisted_8 = /*#__PURE__*/ _createTextVNode(" -- ");
const _hoisted_9 = {
    class: "col-9",
    style: { "margin-top": "2px" }
};
const _hoisted_10 = /*#__PURE__*/ _createTextVNode(" , ");
const _hoisted_11 = { class: "fw-bold" };
const _hoisted_12 = { class: "row ms-2 me-2" };
const _hoisted_13 = { class: "col-12 mb-3 text-end" };
const _hoisted_14 = { class: "fw-bold mb-0" };
const _hoisted_15 = { class: "text-muted" };
const _hoisted_16 = /*#__PURE__*/ _createElementVNode("br", null, null, -1);
const _hoisted_17 = {
    key: 0,
    class: "mb-4"
};
const _hoisted_18 = /*#__PURE__*/ _createElementVNode("div", { class: "seperator" }, null, -1);
const _hoisted_19 = [
    _hoisted_18
];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_product_delivery_time = _resolveComponent("g-product-delivery-time");
    return (_ctx.isVisible)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_1, [
                (_ctx.hasOptions)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _hoisted_4,
                            _createElementVNode("div", _hoisted_5, [
                                _createElementVNode("div", _hoisted_6, " Einzelpreis, " + _toDisplayString(_ctx.currentItem?.itemNumber), 1),
                                _createElementVNode("div", _hoisted_7, [
                                    ((_ctx.currentItem?.price ?? 0) > 0)
                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                            _createTextVNode(_toDisplayString(_ctx.currentItem?.priceFormatted), 1)
                                        ], 64))
                                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                            _hoisted_8
                                        ], 64))
                                ])
                            ]),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (item) => {
                                return (_openBlock(), _createElementBlock("div", {
                                    class: _normalizeClass(["row mb-2", [item.valueName === '$' ? 'pb-1 border-bottom' : '']])
                                }, [
                                    _createElementVNode("div", _hoisted_9, [
                                        _createTextVNode(_toDisplayString(item.caption) + " ", 1),
                                        (item.entryValue1)
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                _hoisted_10,
                                                _createElementVNode("span", _hoisted_11, _toDisplayString(item.entryValue1), 1)
                                            ], 64))
                                            : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", {
                                        class: _normalizeClass(["col-3 text-end", [item.valueName === '$' ? 'fw-bold' : '']])
                                    }, _toDisplayString(item.priceFormated), 3)
                                ], 2));
                            }), 256))
                        ])
                    ]))
                    : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("h3", _hoisted_14, _toDisplayString(_ctx.getPriceFormatted), 1),
                        (_ctx.currentItem?.priceNotes)
                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.currentItem?.priceNotes, (note) => {
                                return (_openBlock(), _createElementBlock(_Fragment, null, [
                                    _createElementVNode("span", _hoisted_15, _toDisplayString(note.text), 1),
                                    _hoisted_16
                                ], 64));
                            }), 256))
                            : _createCommentVNode("", true),
                        _createVNode(_component_g_product_delivery_time, {
                            options: _ctx.getDeliveryTime,
                            class: "justify-content-end mt-1"
                        }, null, 8, ["options"])
                    ])
                ])
            ]),
            (_ctx.showSeperator)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_19))
                : _createCommentVNode("", true)
        ], 64))
        : _createCommentVNode("", true);
}
